<template>
  <div class="bimModelAttributes">
    <MapModal
      v-if="ifModelAttributes"
      class="newModelPosition hierarchy2"
      :close="close"
      :modalNode="modalNode"
      title="构件属性列表"
      id="modelAttributes"
      :class="{
        'y-2': propertyListShow,
      }"
      style="--hierarchyY: 380px"
    >
      <template slot="content">
        <div class="content">
          <el-tabs
            v-model="activeName"
            type="border-card"
            @tab-click="handleClick"
          >
            <el-tab-pane label="设计属性" name="first">
              <span slot="label"><i class="el-icon-shezhi"></i>设计属性</span>
              <div class="table propertyList">
                <el-table :data="modelAttributesData" ref="multipleTable">
                  <el-table-column
                    prop="Alias"
                    class="first-col"
                    label="属性"
                    align="left"
                  >
                  </el-table-column>
                  <el-table-column label="值" width="171" align="left">
                    <template slot-scope="scope">
                      {{ scope.row.Value }} {{ scope.row.Unit }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="建设属性" name="second"
              ><span slot="label"
                ><i class="el-icon-paperclip"></i>建设属性</span
              >
              <el-radio-group
                v-model="constructionAttribute"
                style="padding-top: 10px"
              >
                <el-radio :label="1">进度</el-radio>
                <el-radio :label="2">质量</el-radio>
                <el-radio :label="3">安全</el-radio>
                <el-radio :label="4">造价</el-radio>
              </el-radio-group>
              <!-- 进度 -->
              <div
                class="table propertyList"
                v-if="constructionAttribute === 1"
              >
                <el-table
                  :data="processData"
                  ref="multipleTable"
                  :empty-text="processEmpty"
                >
                  <el-table-column label="开工时间" prop="actualStartTime" />
                  <el-table-column
                    label="完成时间"
                    align="left"
                    prop="actualEndTime"
                  />
                </el-table>
              </div>
              <!-- 造价 -->
              <div v-if="constructionAttribute === 4">
                <!-- <div class="textSelect" style="justify-content: left;">
                  <p>工程标段</p>
                  <el-select v-model="isProjectCost" placeholder="请选择">
                    <el-option
                      class="selectStyle"
                      v-for="item in projectCostOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="flexTextSelect">
                  <div class="textSelect">
                    <p>工程专业</p>
                    <el-select v-model="isProjectCost" placeholder="请选择">
                      <el-option
                        class="selectStyle"
                        v-for="item in projectCostOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="textSelect" style="margin-left: 13px;">
                    <p>单位工程</p>
                    <el-select v-model="isProjectCost" placeholder="请选择">
                      <el-option
                        class="selectStyle"
                        v-for="item in projectCostOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div> -->
                <div class="table propertyList">
                  <p
                    style="
                      color: rgba(0, 255, 255, 0.9);
                      height: 32px;
                      line-height: 32px;
                      font-size: 13px;
                      font-weight: bold;
                    "
                  >
                    {{ fullName }}
                  </p>
                  <el-table :data="costList" ref="multipleTable" height="210">
                    <el-table-column label="" prop="name" />
                    <el-table-column label="" prop="amount" />
                  </el-table>
                </div>
              </div>
              <!-- 安全 -->
              <div v-if="constructionAttribute === 3">
                <div class="textSelect" style="justify-content: left">
                  <p>安全信息</p>
                  <el-select
                    v-model="isSafetyInformation"
                    @change="getSafetyOrRiskList"
                    placeholder="请选择"
                  >
                    <el-option
                      class="selectStyle"
                      v-for="item in safetyInformation"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!-- 巡检安全问题 -->
                <div class="table propertyList">
                  <el-table
                    :data="safetyOrRiskList"
                    ref="multipleTable"
                    height="260"
                    v-if="isSafetyInformation === 1"
                  >
                    <el-table-column label="检查类型" prop="checkType" />
                    <el-table-column label="检查内容" prop="checkContent" />
                    <el-table-column label="当前状态" prop="currentState" />
                    <el-table-column label="检查日期" prop="checkTime" />
                  </el-table>
                </div>
                <!-- 跟踪风险源 -->
                <div class="table propertyList">
                  <el-table
                    :data="safetyOrRiskList"
                    ref="multipleTable"
                    height="260"
                    v-if="isSafetyInformation === 2"
                  >
                    <el-table-column label="类别" prop="kind" />
                    <el-table-column label="风险描述" prop="risk" />
                    <el-table-column label="等级" prop="level" />
                    <el-table-column label="当前状态" prop="status" />
                    <el-table-column label="创建时间" prop="riskCreatedTime" />
                  </el-table>
                </div>
              </div>
              <!-- 质量 -->
              <div
                class="table propertyList"
                v-if="constructionAttribute === 2"
              >
                <div class="collapseFlex">
                  <el-collapse v-model="activeNames">
                    <el-collapse-item
                      v-if="managePropertyData && managePropertyData.length > 0"
                      :title="managePropertyData[0].content"
                    >
                      <div class="table propertyList">
                        <el-table
                          :data="tableData"
                          style="width: 100%"
                          height="260"
                          :header-cell-style="{
                            color: 'rgba(255, 255, 255, 0.9)',
                          }"
                        >
                          <el-table-column
                            width="100"
                            prop="partName"
                            :show-overflow-tooltip="true"
                            label="部位"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="status"
                            :show-overflow-tooltip="true"
                            label="当前状态"
                            align="center"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="isTemp"
                            :show-overflow-tooltip="true"
                            label="是否为临时"
                            align="center"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="auditTime"
                            :show-overflow-tooltip="true"
                            label="批准日期"
                            align="center"
                          >
                          </el-table-column>

                          <el-table-column
                            prop="remarks"
                            :show-overflow-tooltip="true"
                            label=""
                            align="center"
                          >
                            <template slot-scope="scope" style="width: 100%">
                              <el-button
                                size="mini"
                                type="primary"
                                style="line-height: 10px"
                                round
                                icon="small-operation-btn el-icon-view"
                                @click="openWindow(scope.row.url)"
                              ></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item
                      v-for="(item, index) in collapseList"
                      :title="item.content"
                      :name="index + 1"
                      :key="item.id"
                    >
                      <div class="table propertyList">
                        <el-table
                          :data="item.children"
                          style="width: 100%"
                          height="260"
                          :header-cell-style="{
                            color: 'rgba(255, 255, 255, 0.9)',
                          }"
                        >
                          <el-table-column
                            width="100"
                            prop="partName"
                            :show-overflow-tooltip="true"
                            label="部位"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="status"
                            :show-overflow-tooltip="true"
                            label="当前状态"
                            align="center"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="isTemp"
                            :show-overflow-tooltip="true"
                            label="是否为临时"
                            align="center"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="auditTime"
                            :show-overflow-tooltip="true"
                            label="批准日期"
                            align="center"
                          >
                          </el-table-column>

                          <el-table-column
                            prop="remarks"
                            :show-overflow-tooltip="true"
                            label=""
                            align="center"
                          >
                            <template slot-scope="scope" style="width: 100%">
                              <el-button
                                size="mini"
                                type="primary"
                                style="line-height: 10px"
                                round
                                icon="small-operation-btn el-icon-view"
                                @click="openWindow(scope.row.url)"
                              ></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="运维属性" name="third"
              ><span slot="label"><i class="el-icon-wallet"></i>运维属性</span>
              <div class="table propertyList">
                <el-table :data="omData" ref="multipleTable">
                  <el-table-column label="运维属性" />
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div> </template
    ></MapModal>
    <MapModal class="attribute-details">
      <template slot="content">
        <div class="content upload"></div>
      </template>
    </MapModal>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import {
  getBimModelAttributesList,
  getDuAnQualityFamilyList,
  getDuAnQualityDetailsList,
  getDuAnProcessList,
  getDuAnInspectionSecurityList,
  getDuAnTrackingRiskList,
  getDuAnCostFamilyList,
  getDuAnQualityOthersList,
  getDuAnQualityOthersDetailsList,
} from "@/api/api";
import md5 from "js-md5";
export default {
  name: "model-attributes",
  components: {
    MapModal,
  },
  computed: {},
  props: ["fullName", "propertyListShow", "modelTender"],
  data() {
    return {
      activeNames: ["1"],
      omData: [],
      processData: [],
      processEmpty: null,
      safetyOrRiskList: [],
      costList: [],
      constructionAttribute: 1,
      isSafetyInformation: 1,
      safetyInformation: [
        {
          value: 1,
          label: "巡检安全问题",
        },
        {
          value: 2,
          label: "跟踪风险源",
        },
      ],
      activeName: "first",
      ifModelAttributes: false,
      modelAttributesData: null,
      managePropertyData: null,
      tableData: [],
      collapseList: [],
      modalNode: {
        program: {
          show: true, // 默认展示
          loading: false, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   x: 106,
          //   y: -380,
          // },
          width: "700px",
          height: "450px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
            canmove: {
              //当前拖动状态
              state: true,
            },
          },
        },
      },
    };
  },
  watch: {
    fullName: function (newVal, oldVal) {
      this.getBimModelAttributesList();
      this.getProcessList();
      this.getSafetyOrRiskList(1);
      this.getCostFamilyList();
      this.getDuAnQualityOthersList();
    },
  },
  created() {
    if (this.fullName) {
      this.getBimModelAttributesList();
      this.getProcessList();
      this.getSafetyOrRiskList(1);
      this.getCostFamilyList();
      this.getDuAnQualityOthersList();
    }
  },
  methods: {
    handleClick(tab) {
      if (tab.name === "second") {
        this.constructionAttribute = 1;
      }
    },
    getDuAnQualityOthersList() {
      getDuAnQualityOthersList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        fullName: this.fullName,
      }).then((res) => {
        this.collapseList = [];
        if (res.data.data.length > 0) {
          this.collapseList = this.collapseList.concat(res.data.data);
          this.getDuAnQualityOthersDetailsList();
        }
      });
    },
    getDuAnQualityOthersDetailsList() {
      console.log("collapseList", this.collapseList);
      if (this.collapseList.length < 30) {
        this.collapseList.forEach((item) => {
          getDuAnQualityOthersDetailsList({
            projectId: window.sessionStorage.getItem("nowProjectId"),
            fullName: this.fullName,
            kind: item.kind,
          }).then((res) => {
            if (res.data.data.length > 0) {
              item.children = res.data.data;
            }
          });
        });
      }
    },
    // 获取进度数据
    getProcessList() {
      getDuAnProcessList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        fullName: this.fullName,
        tender: this.modelTender,
      }).then((res) => {
        this.processEmpty = null;
        this.ifModelAttributes = true;
        this.modalNode.program.loading = false;
        if (res.data.code === 500) return;
        const value = res.data.data[0];
        if (res.data.data.length > 0 && value.status == 200) {
          this.processData = res.data.data;
        } else if (res.data.data.length > 0 && value.status == 400) {
          this.processEmpty = `暂无数据：${value.daoModelName}`;
          this.processData = [];
        }
      });
    },
    // 获取安全数据
    getSafetyOrRiskList(type) {
      // 1 巡检安全
      if (type == 1) {
        getDuAnInspectionSecurityList({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          fullName: this.fullName,
        }).then((res) => {
          console.log(res.data.data);
          if (res.data.data.length > 0) {
            this.ifModelAttributes = true;
            this.modalNode.program.loading = false;
            this.safetyOrRiskList = res.data.data;
          } else {
            this.safetyOrRiskList = [];
          }
        });
      }
      // 2 跟踪风险
      if (type == 2) {
        getDuAnTrackingRiskList({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          fullName: this.fullName,
        }).then((res) => {
          console.log(res.data.data);
          if (res.data.data.length > 0) {
            this.ifModelAttributes = true;
            this.modalNode.program.loading = false;
            this.safetyOrRiskList = res.data.data;
          } else {
            this.safetyOrRiskList = [];
          }
        });
      }
    },
    // 获取造价数据
    getCostFamilyList() {
      getDuAnCostFamilyList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        fullName: this.fullName,
      }).then((res) => {
        console.log(res.data.data, "造价");
        if (res.data.data.length > 0) {
          this.ifModelAttributes = true;
          this.modalNode.program.loading = false;
          const {
            price,
            zerosetAmount,
            changeAmount,
            changedAmount,
            deliveryCount,
          } = res.data.data[0];
          this.costList = [
            {
              name: "总造价(万元)",
              amount: price,
            },
            {
              name: "零号台账金额(万元)",
              amount: zerosetAmount,
            },
            {
              name: "变更金额(万元)",
              amount: changeAmount,
            },
            {
              name: "支付金额(万元)",
              amount: deliveryCount,
            },
            {
              name: "已经完成金额(万元)",
              amount: changedAmount,
            },
          ];
        } else {
          this.costList = [];
        }
      });
    },
    close() {
      this.ifModelAttributes = false;
      this.modelAttributesData = null;
      this.activeName = "first";
      this.isSafetyInformation = 1;
    },
    getBimModelAttributesList() {
      this.modalNode.program.loading = true;
      this.close();
      getBimModelAttributesList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        fullName: this.fullName,
      })
        .then((res) => {
          if (
            res.data.code == 200 &&
            res.data.data.length > 0 &&
            res.data.data[0].attributes
          ) {
            this.modalNode.program.loading = false;
            this.ifModelAttributes = true;
            this.modelAttributesData = JSON.parse(res.data.data[0].attributes);
          }
        })
        .catch((error) => {
          console.log(error);
          this.modalNode.program.loading = false;
          this.$notify({
            title: "获取数据失败，请稍后再试",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.close();
        });
      getDuAnQualityFamilyList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        fullName: this.fullName,
      })
        .then((res) => {
          if (res.data.code == 200 && res.data.data.length > 0) {
            console.log(res.data.data);
            this.modalNode.program.loading = false;
            this.managePropertyData = res.data.data;
            this.showDetails();
          }
        })
        .catch((error) => {
          console.log(error);
          this.modalNode.program.loading = false;
          this.$notify({
            title: "获取数据失败，请稍后再试",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          // this.close();
        });
    },
    showDetails() {
      this.tableData = [];
      getDuAnQualityDetailsList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        fullName: this.fullName,
      })
        .then((res) => {
          if (res.data.code == 200 && res.data.data.length > 0) {
            this.tableData = res.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "获取数据失败，请稍后再试",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    openWindow(url, title, w = "800", h = "600") {
      const dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : screen.left;
      const dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : screen.top;

      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

      const left = width / 2 - w / 2 + dualScreenLeft;
      const top = height / 2 - h / 2 + dualScreenTop;
      const newWindow = window.open(
        this.processLinks(url),
        title,
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          top +
          ", left=" +
          left,
        "_search"
      );
      // alert(this.processLinks2(url));
      if (window.focus) {
        newWindow.focus();
      }
    },
    processLinks(url) {
      let _foreignRootUrl = "http://172.16.52.130:8000",
        qualityUrl = url,
        partid,
        ut,
        tk,
        newUrl;
      ut = Date.parse(new Date());
      partid = qualityUrl.split("?")[1];
      tk = this.getMd5(ut);
      newUrl = `${_foreignRootUrl}/quality/deliver-cert?id=${partid}&tk=${tk}&ut=${ut}`;
      return newUrl;
    },
    processLinks2(url) {
      let _foreignRootUrl = "http://172.16.52.130:8000",
        partid = url.split("?")[1];
      return `${_foreignRootUrl}/quality/deliver-cert?id=${partid}&instanceid=E1631649A4D7479DA09A4ED173694800`;
    },
    getMd5(time) {
      var hash = md5("BIM" + "@" + time);
      return hash;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.content {
  padding: 10px;
  .el-tabs {
    margin-top: 10px;
  }
  .el-tabs--border-card {
    background: none;
    border: none;
    box-shadow: none;
    margin-bottom: 20px;
    /deep/ & > .el-tabs__header {
      background: none;
      border: none;
      .el-tabs__nav-wrap {
        background: none;
        &::after {
          background: none;
        }
        .el-tabs__item {
          border-right: none;
          border-left: none;
          padding: 0;
          width: 81px; //81px;
          @include lheight(30);
          text-align: center;
          text-indent: -2px;
          letter-spacing: 1px;
          // @include font_color("t_color_op1");
          color: #fff;
          span {
            display: inline-block;
            @include lheight(30);
            font-size: 12px;
            text-indent: 1px;
            i {
              @include lheight(30);
              font-size: 12px;
              margin-right: 1px;
            }
          }
          &.is-active {
            background-color: #2aabe9 !important;
            color: #fff !important;
            border-right: none;
            border-left: none;
          }
        }
      }
      .el-tabs__nav-next,
      .el-tabs__nav-prev {
        line-height: 29px;
      }
    }
    /deep/ & > .el-tabs__content {
      padding: 0;
    }
  }

  // /deep/ input.el-input__inner {
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  //   white-space: nowrap;
  //   background: none;
  //   padding: 0 10px;
  //   font-size: 14px;
  //   height: 26px !important;
  //   line-height: 26px;
  //   color: rgba(255, 255, 255, 0.9) !important;
  // }
  /deep/ .el-form-item__label {
    color: rgba(255, 255, 255, 0.9) !important;
    line-height: 30px;
    font-size: 12px;
  }
  /deep/ .el-radio__label {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
  /deep/ .el-form-item__content {
    color: #fff;
  }

  /deep/ .el-divider {
    background: transparent;
    margin: 20px 0 0 0;
    height: auto;
  }
  /deep/ .el-divider__text {
    background: transparent;
    color: #fff;
    font-size: 14px;
    transform: inherit;
    position: inherit;
    padding: 0;
    width: auto;
    display: inline-block;
  }
  /deep/ .el-form-item__content {
    line-height: 30px;
  }
  /deep/ .el-form.settings {
    border-bottom-width: 0px;
    border-bottom-style: solid;
    border-bottom-color: rgba(245, 245, 245, 0.6) !important;

    padding-bottom: 5px;
    padding-top: 5px;
    width: 100% !important;
    margin: 0 auto;
    margin-bottom: 30px;
    .el-form-item__label {
      line-height: 32px;
      font-size: 13px;
      font-weight: bold;
      text-indent: 2px;
      color: rgba(0, 255, 255, 0.9) !important;
    }
  }
  /deep/ .el-form.settings:last-child {
    border-bottom-width: 0;
  }
  .operation-view {
    width: auto;
    display: inline-block;
    height: auto;
    background-color: rgba(42, 183, 255, 0.9) !important;
    margin-left: 8px;
    line-height: 1.6;
    border-radius: 6px 6px;
    padding: 0 6px;
    position: relative;
    cursor: pointer;
    font-size: 12px;
  }
  /deep/ .table {
    z-index: 999999999999 !important;
  }

  .attribute-details {
    .content {
      padding: 40px 40px 60px;
      background: #303030;
    }
    /deep/.el-table__row {
      background: transparent !important;
    }

    /deep/.el-table,
    /deep/.el-table--fit,
    /deep/.el-table--enable-row-hover,
    /deep/.el-table--enable-row-transition {
      background: transparent !important;
    }

    /deep/.el-table__header-wrapper,
    /deep/.el-table__body-wrapper,
    /deep/.is-scrolling-none {
      margin: 0 auto !important;
    }

    /deep/.el-table__header {
      width: 100% !important;
    }

    /deep/ .el-table--scrollable-x .el-table__body-wrapper {
      overflow: hidden;
    }

    .cell,
    /deep/.el-tooltip {
      width: auto !important;
      background: transparent !important;
    }
    /deep/ .el-table th,
    /deep/ .el-table tr {
      background: transparent !important;
    }
    /deep/th {
      background-color: transparent !important;
      text-align: left !important;
      border-bottom: 1px solid #b0b0b0;
    }
    /deep/th:first-child {
      border-left: 0;
    }
    /deep/ th:last-child td {
      text-align: center !important;
      background: transparent !important;
    }
    /deep/tr td:last-child {
      text-align: center;
    }
    /deep/ td {
      color: white !important;
      padding: 5px 0;
      border-bottom: 1px solid #b0b0b0;
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: rgba(238, 247, 255, 0.12) !important;
    }
    /deep/.el-table--border::after,
    /deep/ .el-table--group::after,
    /deep/ .el-table::before {
      background-color: #b0b0b0;
    }

    /deep/ input.el-input__inner {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      background: none;
      padding: 0 10px;
      font-size: 14px;
      height: 36px !important;
      line-height: 36px;
      border: 0;
    }
    .upbtn {
      margin: 8px 0 10px 0;
    }
    .upload {
      div[res="upload"] {
        display: flex;
        align-items: center;
      }

      .el-upload__tip {
        color: #ccc;
        margin: 0 0 0 35px;
      }
      .el-table--striped .el-table__body tr.el-table__row--striped td {
        background: transparent;
      }
    }
    .cell {
      button {
        padding: 5px 8px;
        font-size: 14px;
      }
    }
  }
  .table.propertyList {
    margin: 0 !important;
    position: initial;
    width: 100%;
    max-width: inherit;
    height: auto;
    background: transparent !important;
    h3 {
      font-size: 12px;
      text-indent: 19px;

      i.el-icon-close {
        width: 30px;
        margin: 6px 12px 0 0;
      }
    }
    .el-table {
      width: auto;
      margin: 0;
      table.el-table__header {
        width: 100% !important;
        max-width: initial !important;
      }

      /deep/ .el-table__body-wrapper {
        &::-webkit-scrollbar {
          // 整个滚动条
          width: 0; // 纵向滚动条的宽度
          background: rgba(213, 215, 220, 0.3);
          border: none;
        }
        &::-webkit-scrollbar-track {
          // 滚动条轨道
          border: none;
        }
      }

      .el-button--mini,
      .el-button--mini.is-round {
        padding: 3px 10px;
      }
      /deep/ .el-table__empty-text {
        width: 100% !important;
      }
    }
    .el-table::before {
      height: 0px !important;
    }
  }
}
.flexTextSelect {
  display: flex;
  align-items: center;
  width: 85%;
  margin: 0 14px;
}
.textSelect {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100% !important;
  margin: 0 auto;
  margin-top: 10px;
  p {
    width: 100px;
    line-height: 32px;
    font-size: 13px;
    font-weight: bold;
    text-indent: 2px;
    color: rgba(0, 255, 255, 0.9) !important;
  }
  /deep/ .el-input {
    @include input_select(185, 32);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: none;
    font-size: 14px;
    height: 36px !important;
    line-height: 36px;
    color: rgba(255, 255, 255, 0.9) !important;
  }
  /deep/ .el-input__inner {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: none;
    font-size: 14px;
    height: 36px !important;
    line-height: 36px;
    color: rgba(255, 255, 255, 0.9) !important;
  }
}

.selectStyle {
  font-size: 12px;
  padding: 0 10px;
  height: 28px;
  line-height: 28px;
  overflow: hidden;
  width: 100%;
  border-radius: 3px 3px;
}
.selectStyle.el-select-dropdown__item.selected {
  background-color: rgba(42, 183, 255, 0.9) !important;
  color: #ffffff;
  font-weight: 700;
}
.selectStyle.el-select-dropdown__item:hover {
  background-color: rgba(42, 183, 255, 0.9) !important;
  color: #ffffff;
}

.collapseFlex {
  padding: 5px;
  border: none;
  /deep/.el-collapse-item__header {
    font-size: 13px;
    font-weight: bold;
    text-indent: 2px;
    color: rgba(0, 255, 255, 0.9) !important;
    background-color: transparent !important;
    border: none;
  }

  /deep/.el-collapse {
    border: none;
  }
  /deep/.el-collapse-item__wrap {
    background: transparent !important;
    color: #fff !important;
    border-top-color: #b0b0b0 !important ;
    border-bottom: 1px solid #b0b0b0 !important;
  }
  /deep/.el-collapse-item__content {
    color: #fff !important;
    padding-bottom: 0px;
  }
  /deep/.el-scrollbar__wrap:not(.el-select-dropdown__wrap) {
    height: inherit;
  }
}
</style>
